import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './StandLaunch.css';

const normaliseStandCode = (value) => String(value || '').replace(/\D/g, '').slice(0, 6);

const StandCodeEntry = () => {
    const navigate = useNavigate();
    const [standCode, setStandCode] = useState('');
    const [error, setError] = useState(null);

    const handleSubmit = (event) => {
        event.preventDefault();
        const safeCode = normaliseStandCode(standCode);

        if (safeCode.length !== 6) {
            setError('Enter the 6-digit stand code from the QR card.');
            return;
        }

        navigate(`/s/${safeCode}`);
    };

    return (
        <div className="stand-launch-page">
            <div className="stand-launch-card stand-code-entry-card">
                <div className="stand-launch-hero">
                    <div>
                        <p className="stand-launch-kicker">Stand Access</p>
                        <h1>Enter a Stand Code</h1>
                        <p className="stand-launch-copy">
                            If the camera is awkward in the field, type the 6-digit code from the stand QR card and jump straight into scoring.
                        </p>
                    </div>
                </div>

                <form className="stand-code-entry-form" onSubmit={handleSubmit}>
                    <label htmlFor="stand-code-input">Stand code</label>
                    <input
                        id="stand-code-input"
                        type="text"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength={6}
                        value={standCode}
                        onChange={(event) => {
                            setStandCode(normaliseStandCode(event.target.value));
                            setError(null);
                        }}
                        placeholder="123456"
                    />
                    {error ? <p className="stand-code-entry-error">{error}</p> : null}
                    <div className="stand-launch-actions">
                        <button type="submit" className="stand-launch-primary">Open Stand</button>
                        <button type="button" className="stand-launch-secondary" onClick={() => navigate('/dashboard/score/clay')}>
                            Back to Clay Scoring
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default StandCodeEntry;
